import { useEffect, useRef, useState } from "react";
import {
  HiOutlineChevronRight,
  HiOutlineMenu,
  HiSearch,
  HiOutlineChevronDown,
} from "react-icons/hi";
import Image from "next/legacy/image";
import Link from "next/link";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import NavItems from "@/components/NavItems";
import MobileNavItem from "@/components/NavItems/MobileNavItem";
import TopHeaderMobile from "@/components/WorldWideMenu/TopHeaderMobile";
import HeaderSearch from "./HeaderSearch";
import Styles from "./index.module.scss";
import { IoLocationSharp, IoCloseOutline, IoSearch } from "react-icons/io5";
import { FiShoppingCart } from "react-icons/fi";
import { IoMdMail } from "react-icons/io";
import { PDP_LABELS } from "../detailsComponent/helper";
import { BsSearch } from "react-icons/bs";
import { getLinkTargetTab } from "@/utils/helper";

// static data for url
const formatUrl = {
  bathrooms: "/browse/Bathroom",
  showers: "/browse/Showering",
  commercial: "/browse/Commercial",
  baños: "/browse/Baños",
  duchas: "/browse/Duchas",
  institucional: "/browse/Institucional",
  cocina: "/browse/Cocina",
  kitchen: "/browse/Kitchen",
};
export default function HeaderSection({
  navData = {},
  world = {},
  setIsHovered,
  visible,
}) {
  const router = useRouter();
  const { locale = "" } = router;
  const { logo = {}, primaryNav = [] } = navData;
  const [top, setTop] = useState(true);
  //desktop- state
  const [navOpen, setNavOpen] = useState(false);
  const [secondaryNavItem, setSecondaryNavItem] = useState([]);
  const [secondaryNavLabel, setSecondaryNavLabel] = useState("");
  const [secondaryNavLabelUrl, setSecondaryNavLabelUrl] = useState("");
  const subNavRef = useRef(null); // ref for height animation
  // mobile state
  const [secondaryNavItemMobile, setSecondaryNavItemMobile] = useState([]);
  const [secondaryNavLabelMobile, setSecondaryNavLabelMobile] = useState("");
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const [searchVisible, setSearchVisible] = useState(false);

  const {
    items: [
      {
        fields: {
          topNav: [{ fields: { navItems: topNavMenu = [] } = {} } = {}] = [],
        } = {},
      } = {},
    ] = [],
  } = world || {};

  useEffect(() => {
    const scrollHandler = () => {
      window.scrollY > 10 ? setTop(false) : setTop(true);
    };
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, [top]);

  useEffect(() => {
    if (openMobileMenu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [openMobileMenu]);

  const handleSecondaryNav = (e, secondaryNav) => {
    e.preventDefault();

    if (
      secondaryNavLabel.toUpperCase() ===
        secondaryNav?.fields?.label.toUpperCase() &&
      navOpen
    ) {
      setNavOpen(false);
      setSecondaryNavLabel("");
      setSecondaryNavLabelUrl("");
    } else {
      setNavOpen(true);
      setSecondaryNavItem(secondaryNav?.fields?.secondaryNavigation);
      setSecondaryNavLabel(secondaryNav?.fields?.label);
      setSecondaryNavLabelUrl(secondaryNav?.fields?.url);
    }
  };

  const secondaryNavItemFuncMobile = (e, secondaryNav) => {
    if (!secondaryNav?.fields?.secondaryNavigation) setOpenMobileMenu(false);
    if (
      secondaryNavLabelMobile &&
      secondaryNavLabelMobile.toUpperCase() ===
        secondaryNav?.fields?.label.toUpperCase()
    ) {
      setSecondaryNavItemMobile([]);
      setSecondaryNavLabelMobile("");
      setSecondaryNavLabelUrl("");
    } else {
      setSecondaryNavItemMobile(secondaryNav?.fields?.secondaryNavigation);
      setSecondaryNavLabelMobile(secondaryNav?.fields?.label);
      setSecondaryNavLabelUrl(secondaryNav?.fields?.url);
    }
  };

  // adjust height of submenu wrapper when navOpen toggles
  useEffect(() => {
    const el = subNavRef.current;
    if (!el) return;
    if (navOpen && secondaryNavItem && secondaryNavItem.length) {
      // set explicit height to trigger transition
      el.style.height = el.scrollHeight + "px";
      // after transition complete, clear height so content can grow/shrink naturally
      const handler = () => {
        el.style.height = "auto";
        el.removeEventListener("transitionend", handler);
      };
      el.addEventListener("transitionend", handler);
    } else {
      // closing: fix current height then collapse to 0
      const current = el.scrollHeight;
      el.style.height = current + "px";
      // force reflow to apply height before collapsing
      // eslint-disable-next-line no-unused-expressions
      el.offsetHeight;
      el.style.height = "0px";
    }
  }, [navOpen, secondaryNavItem]);

  const handleSearch = () => {
    setSearchVisible(prev => !prev);
    setOpenMobileMenu(false);
  };

  const handleHamburger = () => {
    setOpenMobileMenu(true);
    setSearchVisible(false);
    setSecondaryNavLabelMobile("");
    if (openMobileMenu) {
      setOpenMobileMenu(false);
      setSearchVisible(false);
    }
  };

  const handleIcon = (argLabel, argUrl) => {
    if (secondaryNavLabelMobile === argLabel) {
      return <HiOutlineChevronDown size={20} />;
      if (argUrl !== "#") {
        return <HiOutlineChevronRight size={20} />;
      }
    }

    return <HiOutlineChevronRight size={20} />;
  };

  const topNavRightMenu = topNavMenu?.slice(3);

  const renderIcon = index => {
    switch (index) {
      case "E-shop":
        return (
          <div className="self-center">
            <FiShoppingCart size={18} />
          </div>
        );

      case "Địa chỉ mua hàng":
      case "Find a Store":
        return (
          <div className="self-center">
            <IoLocationSharp size={18} />
          </div>
        );

      case "Contact Us":
      case "Liên hệ":
        return (
          <div className="self-center">
            <IoMdMail size={18} />
          </div>
        );

      default:
        return <>&nbsp;</>;
    }
  };

  return (
    <>
      {/* Header desktop --> start */}
      <div
        className={`${
          !top && `bg-white shadow-xl`
        } lg:block hidden ${Styles.headerContainer}`}
        style={{
          transform: visible ? "translateY(32px)" : "translateY(0px)",
          transition: "margin-top 0.3s ease",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="header-parent px-4 max-w-screen-lg">
          <div className="flex items-center h-full">
            <ul className="flex h-full text-[#232323]">
              {primaryNav[0]?.fields?.navItems
                ?.slice(0, 3)
                ?.map((navItem, id) => {
                  const isActive =
                    navOpen &&
                    secondaryNavLabel?.toUpperCase() ===
                      navItem?.fields?.label?.toUpperCase();
                  return (
                    <NavItems
                      key={navItem?.sys?.id || id}
                      navItemLabel={navItem?.fields?.label}
                      secondaryNavItemFunc={e => handleSecondaryNav(e, navItem)}
                      linkClass={`${Styles.headerPrimeNavText} text-[#232323] ${locale === "en" ? "!text-[16px]" : ""}`}
                      classNames={`cursor-pointer leading-loose text-[#232323] uppercase px-6 py-6 ${Styles.navItemHoverable} ${isActive ? Styles.navItemActive : ""}`}
                    />
                  );
                })}
            </ul>
          </div>

          {/* brand logo --start */}
          <div className="flex items-center hover:cursor-pointer" tabIndex={0}>
            <Link href="/" className="flex items-center mr-6" legacyBehavior>
              <Image
                src={logo?.fields?.mediaItem?.fields?.asset?.fields?.file?.url}
                alt={logo?.fields?.mediaItem?.fields?.altText}
                aria-label={logo?.fields?.mediaItem?.fields?.altText}
                className="h-6 w-auto mr-2"
                height={75}
                width={132}
                quality={100}
                onClick={() => setNavOpen(false)}
              />
            </Link>
          </div>
          {/* brand logo --end */}

          <div className="flex items-center h-full">
            <ul className="flex h-full">
              {primaryNav[0]?.fields?.navItems?.slice(3)?.map((navItem, id) => (
                <NavItems
                  key={navItem?.sys?.id || id}
                  navItem={navItem}
                  secondaryNavItemFunc={e => handleSecondaryNav(e, navItem)}
                  linkClass={`${Styles.headerPrimeNavText} text-[#232323] ${locale === "en" ? "!text-[16px]" : ""}`}
                  classNames={`cursor-pointer leading-loose font-light text-[#232323] uppercase px-6 py-6 whitespace-nowrap ${Styles.navItemHoverable}`}
                />
              ))}
            </ul>
            <HeaderSearch />
          </div>
        </div>
        <div className="absolute w-full ">
          {/* animation wrapper for desktop subnav */}
          <div
            ref={subNavRef}
            className={`${Styles.subNavWrapper} ${
              navOpen ? Styles.subNavWrapperOpen : ""
            }`}
          >
            {secondaryNavItem && navOpen && (
              <div className="bg-[#e5e5e5] text-[#232323] shadow p-6">
                <div className="max-w-screen-lg mx-auto py-6 px-6">
                  <div className="text-3xl uppercase inline-flex">
                    {secondaryNavLabelUrl ? (
                      <a
                        href={secondaryNavLabelUrl}
                        className={`${Styles.secondaryNavLabel}`}
                      >
                        {secondaryNavLabel}
                      </a>
                    ) : (
                      <span className={`${Styles["secondaryNavLabel-span"]}`}>
                        {secondaryNavLabel}
                      </span>
                    )}
                    <span className="mt-1 ml-4">
                      <HiOutlineChevronRight />
                    </span>
                  </div>
                  <div className="mt-[20px] flex">
                    {secondaryNavItem?.map((secondaryNav, id) => {
                      return (
                        <ul
                          className={`flex flex-col ${secondaryNavLabel === "KITCHEN" || secondaryNavLabel === "PHÒNG BẾP" ? "w-[176px]" : "w-[225px]"} mr-[2%] text-left navMenu`}
                          key={secondaryNav?.sys?.id || id}
                        >
                          {secondaryNav?.fields?.heading?.map(
                            item =>
                              item?.fields?.label !== "#" && (
                                <li
                                  className={`w-full`}
                                  key={item?.fields?.label}
                                >
                                  {item?.fields?.url ? (
                                    <Link
                                      href={item?.fields?.url}
                                      onClick={() => setNavOpen(false)}
                                      target={
                                        item?.fields?.openerType === "New Tab"
                                          ? "_blank"
                                          : "_self"
                                      }
                                      className={`text-[14px] block lg:mb-[5px] leading-tight font-normal font-HelveticaBold pb-1 !text-[#232323] hover:!text-[#666] ${locale === "vn" ? "" : "whitespace-nowrap"}`}
                                    >
                                      {item?.fields?.label}
                                    </Link>
                                  ) : (
                                    <span
                                      className={`text-[14px] block lg:mb-[5px] leading-tight font-normal !font-[helveticaBold,_Helvetica,_sans-serif] pb-1 !text-[#232323] hover:!text-[#666] ${locale === "vn" ? "" : "whitespace-nowrap"}`}
                                    >
                                      {item?.fields?.label}
                                    </span>
                                  )}
                                </li>
                              )
                          )}
                          {secondaryNav?.fields?.navItems?.map(
                            (navItem, id) =>
                              navItem?.fields?.label !== "#" && (
                                <NavItems
                                  key={navItem?.sys?.id || id}
                                  navItem={navItem}
                                  handleCloseHandle={() => setNavOpen(false)}
                                  linkClass={`${navItem?.fields?.makeBold ? "text-[14px] leading-tight font-[600] font-[HelveticaRoman] text-[#232323] hover:text-[#666]" : "font-[400] text-[#666] hover:text-[#232323] font-[Helvetica-Medium,_Helvetica,_sans-serif] leading-[18px] tracking-wide"} ${navItem?.fields?.url ? "cursor-pointer" : "cursor-text"}`}
                                  classNames={`${navItem?.fields?.makeBold ? "!text-[14px] !leading-tight !font-normal !font-HelveticaBold !mt-[20px]" : "font-[600] text-[13px] font-helveticaMedium"} py-1`}
                                />
                              )
                          )}
                        </ul>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Header desktop --> end */}
      {/* Header mobile --> start */}
      <div
        className={`bg-[#fff] text-[#232323] border-y z-40 sticky top-0 ${
          !top && `bg-white shadow-xl`
        } lg:hidden`}
      >
        {/* Mobile menu header -- start */}
        <div className="flex justify-between items-center h-[60px] p-3 border-b border-[#dbdbdb]">
          <button
            className={`flex ${openMobileMenu ? "text-[#232323]" : "text-[#bebebe]"} hover:cursor-pointer`}
            onClick={() => handleHamburger()}
          >
            {openMobileMenu ? (
              <IoCloseOutline size={30} />
            ) : (
              <HiOutlineMenu size={30} />
            )}
          </button>
          <div className="flex">
            {/* brand logo --start */}
            <div className="flex items-center hover:cursor-pointer">
              <Link href="/" className="flex items-center mr-6" legacyBehavior>
                <Image
                  src={
                    logo?.fields?.mediaItem?.fields?.asset?.fields?.file?.url
                  }
                  alt={logo?.fields?.mediaItem?.fields?.altText}
                  aria-label={logo?.fields?.mediaItem?.fields?.altText}
                  className="h-6 w-auto mr-2"
                  height={60}
                  width={105}
                  quality={100}
                  onClick={() => setOpenMobileMenu(false)}
                />
              </Link>
            </div>
            {/* brand logo --end */}
          </div>
          <button
            className={`flex ${searchVisible ? "text-[#232323]" : "text-[#bebebe]"}`}
            onClick={() => handleSearch()}
          >
            {searchVisible ? (
              <IoCloseOutline size={30} />
            ) : (
              <BsSearch size={30} className="p-[5px]" />
            )}
          </button>
        </div>
        {/* mobile menu header--end */}
        {(openMobileMenu || searchVisible) && (
          <div className="height-max overflow-scroll absolute w-full z-50 bg-black/50 h-screen mb-10 md:mb-0">
            {searchVisible && (
              <div className="flex w-full flex-col bg-[#fff] min-h-screen">
                <div className="p-4 flex w-full justify-center">
                  <HeaderSearch
                    setOpenMobileMenu={e => {
                      setOpenMobileMenu(e);
                      setSearchVisible(false);
                    }}
                  />
                </div>
              </div>
            )}
            {!searchVisible && (
              <div className="h-[stretch] bg-white max-w-[85%] block">
                <div className="w-full bg-[#fff]">
                  {primaryNav[0]?.fields?.navItems?.map((navItem, id) => (
                    <div key={navItem?.sys?.id || id}>
                      <MobileNavItem
                        key={navItem?.sys?.id || id}
                        navItem={{
                          ...navItem,
                          fields: { ...navItem?.fields },
                        }}
                        navItemLabel={navItem?.fields?.label}
                        secondaryNavItemFuncMobile={(e, data) =>
                          secondaryNavItemFuncMobile(e, data)
                        }
                        svgElement={handleIcon(
                          navItem?.fields?.label,
                          navItem?.fields?.url
                        )}
                        linkClass="text-[#000] flex justify-between"
                        classNames="uppercase font-helveticaLight font-bold leading-normal py-[16px] px-[14px] border-b border-[#dbdbdb]"
                      />
                      {secondaryNavItemMobile &&
                        secondaryNavLabelMobile === navItem?.fields?.label && (
                          <div className="bg-[#e5e5e5] text-[#232323] shadow ">
                            <div className="font-helveticaLight font-bold leading-normal py-[16px] px-[14px] border-b border-[#dbdbdb]">
                              {navItem?.fields?.url ? (
                                <a
                                  href={navItem?.fields?.url}
                                  className={`${Styles.secondaryNavLabel}`}
                                >
                                  {locale === "en"
                                    ? "See All " + secondaryNavLabelMobile
                                    : secondaryNavLabelMobile}
                                </a>
                              ) : (
                                <span className={`${Styles.secondaryNavLabel}`}>
                                  {locale === "en"
                                    ? "See All " + secondaryNavLabelMobile
                                    : secondaryNavLabelMobile}
                                </span>
                              )}
                            </div>
                            <div className="">
                              {secondaryNavItemMobile?.map(
                                (secondaryNav, id) => {
                                  return (
                                    <ul
                                      className="flex flex-col pr-8 navMenu"
                                      key={secondaryNav?.sys?.id || id}
                                    >
                                      {secondaryNav?.fields?.heading?.map(
                                        item =>
                                          item?.fields?.label !== "#" && (
                                            <li
                                              key={item?.fields?.label}
                                              onClick={() =>
                                                setOpenMobileMenu(false)
                                              }
                                              className="font-helveticaLight font-bold leading-normal py-[16px] px-[14px] border-b border-[#dbdbdb]"
                                            >
                                              <Link
                                                href={item?.fields?.url || "#"}
                                                target={getLinkTargetTab(
                                                  item?.fields?.openerType
                                                )}
                                                className="text-[16px] leading-tight font-normal font-HelveticaBold pb-1 !text-[#000]"
                                              >
                                                {item?.fields?.label}
                                              </Link>
                                            </li>
                                          )
                                      )}
                                      {secondaryNav?.fields?.navItems?.map(
                                        (navItem, id) =>
                                          navItem?.fields?.label !== "#" && (
                                            <MobileNavItem
                                              key={navItem?.sys?.id || id}
                                              navItem={navItem}
                                              handleCloseHandle={() => {
                                                setOpenMobileMenu(false);
                                                setSecondaryNavItemMobile([]);
                                              }}
                                              linkClass="text-[#000]"
                                              classNames="font-helveticaLight font-bold leading-normal py-[16px] px-[14px] border-b border-[#dbdbdb]"
                                            />
                                          )
                                      )}
                                    </ul>
                                  );
                                }
                              )}
                            </div>
                          </div>
                        )}
                    </div>
                  ))}
                </div>
                <TopHeaderMobile
                  world={world}
                  handleCloseHandle={e => setOpenMobileMenu(e)}
                />
              </div>
            )}
          </div>
        )}

        <div
          className="grid pt-[0.8em] pb-[0.8em] items-center bg-[#232323] text-white text-center font-[HelveticaRoman,Helvetica,sans-serif] text-[11px] md:hidden"
          style={{
            gridTemplateColumns: `repeat(${topNavRightMenu.length}, 1fr)`,
          }}
        >
          {topNavRightMenu?.map((item, index) => (
            <div
              key={item?.sys?.id || index}
              className="h-[40px] border-r border-white/20 pl-[0.5em] pr-[0.5em]"
            >
              <Link
                href={item?.fields?.url}
                target={
                  item?.fields?.openerType === "New Tab" ? "_blank" : "_self"
                }
                className="flex flex-col items-center justify-center h-full gap-1"
              >
                {renderIcon(item?.fields?.label)}
                {item?.fields?.mediaItem?.[0]?.fields?.asset?.fields?.file
                  ?.url ? (
                  <img
                    className="cursor-pointer hover:text-white no-underline h-[28px] hover:!no-underline"
                    src={
                      item?.fields?.mediaItem?.[0]?.fields?.asset?.fields?.file
                        ?.url
                    }
                    alt={item?.fields?.mediaItem?.fields?.altText || ""}
                  />
                ) : (
                  item?.fields?.label
                )}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

HeaderSection.propTypes = {
  navData: PropTypes.shape({
    logo: PropTypes.object,
    primaryNav: PropTypes.arrayOf(PropTypes.object),
  }),
  world: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.object),
  }),
};
